
import {defineComponent, PropType} from "vue";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import {generateCustomCssPreviewUrl} from "@/helpers/functions/route";
import {ContentOverviewRestDto} from "@/api/pharma-cms-content-block/models";

export default defineComponent({
  name: "PreviewOverviewItem",
  components: {BaseDeleteButton},
  emits: ["update", "delete"],
  props: {
    contentBlock: {
      type: Object as PropType<ContentOverviewRestDto>,
      required: true
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    }
  },
  computed: {
    previewPath(): string | null {
      return generateCustomCssPreviewUrl(this.contentBlock.id);
    }
  },
});
